import { render } from "./ProviderCreate.vue?vue&type=template&id=5cc37cde"
import script from "./ProviderCreate.vue?vue&type=script&lang=js"
export * from "./ProviderCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__